module.exports = __webpack_public_path__ + "static/media/gradient.83e4fe55.svg";